import http from "../../config/http-common";

class couponCodeService{
    ValidateCode(couponCode) {
        return http.get(`couponcode/`+couponCode);
    }
}

export default new couponCodeService();